export default "__VITE_ASSET___R6$YZwi__"